import React from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Dialog, DialogContent, DialogTitle, DialogProps } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';

interface IProps {
  open: boolean
  onClose: () => any
  title: string
  titleAlign?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
  children?: any
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  disableBackdropClick?: boolean;
  PaperProps?: DialogProps['PaperProps'] | null; // <- nullable PaperProps
}

const useStyles = makeStyles((theme: Theme) => createStyles({
  appBar: {
    backgroundColor: theme.palette.primary.dark,
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  body: {
    paddingTop: 8,
    [theme.breakpoints.up('md')]: {
      minWidth: 350
    }
  },
}),);

const EditDialog = (props: IProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down('md'));

  const handleClose = (event:Object, reason:string)=>{
    if (reason === 'backdropClick' && props.disableBackdropClick) {
      return;
    } else {
      props.onClose();
    }
  };
  return (
    <Dialog
      open={Boolean(props.open)}
      onClose={handleClose}
      fullScreen={isSmall}
      maxWidth={props.maxWidth}
      PaperProps={props.PaperProps || undefined} // apply PaperProps if provided
    >
      {
          isSmall
            ? (
              <AppBar className={classes.appBar}>
                <Toolbar>
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={props.onClose}
                    aria-label="close"
                    size="large"
                  >
                    <CloseIcon />
                  </IconButton>
                  <Typography
                    variant="h5"
                    className={classes.title}
                    component="span"
                  >
                    {props.title}
                  </Typography>
                </Toolbar>
              </AppBar>
            )
            : (
              <DialogTitle>
                <Typography
                  variant="h5"
                  style={{ margin: 0 }}
                  component="span"
                >
                  {props.title}
                </Typography>
              </DialogTitle>
            )
            }
      <DialogContent>
        <div className={classes.body}>
          {props.children}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default EditDialog;
